import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Button, Input, Loader, Switch } from "ui";

import {
  useSuggestionDiscountSettings,
  useUpdateSuggestionDiscountSettings
} from "../../apis";
import { SectionCard } from "../../components";

import styles from "./SuggestionDiscountSettings.module.scss";

const MAX_VALIDITY_HOURS = 720;

const SuggestionDiscountSettings = () => {
  const { t } = useTranslation();

  const { settings, isLoading } = useSuggestionDiscountSettings();
  const { mutate, isLoading: isSaving } = useUpdateSuggestionDiscountSettings({
    onSuccess: () => toast.success(t("Saved"))
  });

  const [isEnabled, setIsEnabled] = useState(false);
  const [validityHours, setValidityHours] = useState<number | null>(null);

  useEffect(() => {
    if (!settings) {
      return;
    }

    setIsEnabled(settings.isEnabled);
    setValidityHours(settings.validityHours);
  }, [settings]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <SectionCard
      title={t("Cross-sell discount")}
      subtitle={t(
        "When on, a product the assistant suggests can be sold at the discount set " +
          "on its variants — but only together with the item it was suggested for."
      )}
    >
      <div className={styles.settings}>
        <Switch
          label={t("Enabled")}
          checked={isEnabled}
          onChange={(e) => setIsEnabled(e.currentTarget.checked)}
        />

        <Input
          value={validityHours ?? ""}
          type="number"
          onlyInteger={true}
          onChange={(e) =>
            setValidityHours(
              Math.min(+e.target.value, MAX_VALIDITY_HOURS) || null
            )
          }
          placeholder={t("Enter hours")}
          label={t("Offer stays valid for (hours)")}
          min={1}
          max={MAX_VALIDITY_HOURS}
          maxLength={3}
        />

        <Button
          disabled={isSaving || !validityHours}
          onClick={() => mutate({ isEnabled, validityHours: validityHours ?? 24 })}
        >
          {t("Save")}
        </Button>
      </div>
    </SectionCard>
  );
};

export default SuggestionDiscountSettings;
